import { createFileRoute } from '@tanstack/react-router';
import { AuditPage } from '@/components/AuditPage';

/**
 * Route file para `/audit`. La implementación del page vive en `@/components/AuditPage` —
 * mantener este archivo "tonto" facilita el codesplit que hace TanStack Router y permite
 * importar la página directamente en tests sin instanciar todo el route tree.
 */
export const Route = createFileRoute('/_authenticated/audit')({
  component: AuditPage,
});
